import React from "react";
import WebReceipt from "./WebReceipt";

/**
 * App-shared trip-tracking page (route /app-receipt/:id).
 *
 * Renders the same WebReceipt as /web-receipt — using the same :id param —
 * but hides the payment card and the cancel-trip button (DASH-5282).
 */
const AppReceipt: React.FC = () => <WebReceipt hidePaymentAndCancel />;

export default AppReceipt;
